import React from 'react'
import { Controller } from 'react-hook-form';
import ReactQuill from 'react-quill';

export default function ControlledReactQuill({ name, control, label, disabled = false, required = true }) {
    const quillModules = {
        toolbar: [
            [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline', 'strike'],
            ['clean'],
        ],
    };
    return (
        <Controller
            name={name}
            control={control}
            disabled={disabled}
            render={({ field, fieldState }) => (
                <div className='flex flex-col'>
                    <label className={`text-sm mb-2 ${disabled ? 'opacity-50' : ''}`}>{label} {required && <span className='text-danger'>*</span>}</label>
                    <ReactQuill
                        {...field}
                        readOnly={disabled}
                        theme="snow"
                        modules={quillModules}
                        style={{
                            width: "100%",
                            height: "200px",
                            resize: "horizontal",
                            overflow: "auto",
                            opacity: disabled ? 0.5 : 1
                        }}
                    />
                    {fieldState.error && <p className='text-danger text-xs'>{fieldState.error.message}</p>} 
                </div>
            )}
        />
    )
}
